import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-closeBlack",
  "use": "icon-closeBlack-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-closeBlack\">\n    <path d=\"M1.143.947a.139.139 0 0 0-.196.196l7.91 7.91a.139.139 0 1 0 .196-.196L1.143.947z\" fill=\"#D8D8D8\" stroke=\"#8E8E8E\" stroke-width=\"1.2\" />\n    <path d=\"M8.857.947a.139.139 0 0 1 .196.196l-7.91 7.91a.139.139 0 1 1-.196-.196l7.91-7.91z\" fill=\"#D8D8D8\" stroke=\"#8E8E8E\" stroke-width=\"1.2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol